import React from 'react';
import PropTypes from 'prop-types';

import {constants as destinationConstants} from '@eb/destination-utils';
import {trackAnalyticsEvent} from '@eb/site-analytics';

import ConditionalComponent from 'consumer-utils/components/ConditionalComponent';
import {getWindowObject} from 'js-utils/feature-detection';
import Layout from 'eventbrite_design_system/layout/Layout';

import {
    BUCKETS_PROPTYPES,
    FEATURE_FLAGS_PROPTYPES,
    ORGANIZER_ARTICLE_BUCKET_PROPTYPE,
    FLAT_BUCKET_PROPTYPE,
} from '../constants/propTypes';
import {
    GA_HOME_FEED_CATEGORY,
    GA_VIEW_HOMEPAGE_FEED,
    GA_VIEW_LOGGEDOUT_HOMEPAGE_FEED,
    GA_HOME_CATEGORY,
} from '../constants/analytics';

import feedConfig from '../constants/feedConfig';
import ConnectedFeedBuilder from '../containers/ConnectedFeedBuilder';
import ConnectedHeader from '../containers/ConnectedHeader';
import ConnectedBasePage from './ConnectedBasePage';

import BrowseContainer from '../containers/BrowseContainer';
import {LUX_LABEL_FEED} from '../constants/constants';

import BrowsePageButton from '../components/BrowsePageButton';

const {PLACE_OBJECT_PROPTYPE} = destinationConstants;

const trackSpeedCurveLUX = () => {
    const LUX = getWindowObject('LUX');

    if (LUX) {
        LUX.label = LUX_LABEL_FEED;
    }
};

const applyIEFixes = () => {
    /**
     * IE is returning errors because SVG elements are not correctly mapped when parsing the docs.
     * This post gives a solution to this: https://github.com/Pomax/react-onclickoutside#ie-does-not-support-classlist-for-svg-elements
     */
    if (!('classList' in SVGElement.prototype)) {
        Object.defineProperty(SVGElement.prototype, 'classList', {
            get() {
                return {
                    contains: (className) => (this.className.baseVal.split(' ').indexOf(className) !== -1),
                };
            },
        });
    }
};

export default class FeedPage extends React.Component {
    static propTypes = {
        // feed props
        buckets: BUCKETS_PROPTYPES,
        featureFlags: FEATURE_FLAGS_PROPTYPES,
        placeId: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        currentPlace: PropTypes.string,
        currentPlaceParent: PropTypes.string,
        locations: PropTypes.shape({
            places: PropTypes.arrayOf(PLACE_OBJECT_PROPTYPE),
        }),
        placeType: PropTypes.string,
        slug: PropTypes.string,
        fiveToFollow: PropTypes.arrayOf(ORGANIZER_ARTICLE_BUCKET_PROPTYPE),
        flatBucket: FLAT_BUCKET_PROPTYPE,
        isAuthenticated: PropTypes.bool,
        userId: PropTypes.string,
        handleRestOfContext: PropTypes.func,
        // eslint-disable-next-line react/forbid-prop-types
        originalContext: PropTypes.object,
        // eslint-disable-next-line react/forbid-prop-types
        history: PropTypes.object,
        handleTrackPageButton: PropTypes.func,
    }

    static defaultProps = {
        handleRestOfContext: () => null,
    }

    componentDidMount() {
        const {
            isAuthenticated,
            userId,
            handleRestOfContext,
            originalContext,
        } = this.props;

        let category = GA_HOME_CATEGORY;

        let action = GA_VIEW_LOGGEDOUT_HOMEPAGE_FEED;

        let extraAttributes = {};

        if (isAuthenticated) {
            category = GA_HOME_FEED_CATEGORY;
            action = GA_VIEW_HOMEPAGE_FEED;
            extraAttributes = {dimensions: {userId}};
        }

        trackSpeedCurveLUX();

        applyIEFixes();

        trackAnalyticsEvent({
            category,
            action,
            nonInteraction: true,
            ...extraAttributes,
        });

        handleRestOfContext(originalContext);
    }

    render() {
        return (
            <ConnectedBasePage {...this.props} isHomePage={true}>
                <ConditionalComponent shouldRender={false}>
                    <Layout hasHorizontalGutters={true} maxWidth="large">
                        <ConnectedHeader />

                        <ConnectedFeedBuilder feedConfig={feedConfig} />
                    </Layout>
                </ConditionalComponent>

                <ConditionalComponent shouldRender={true}>
                    <Layout hasHorizontalGutters={true} maxWidth="large">
                        <ConnectedHeader history={this.props.history} />

                        <BrowsePageButton
                            handleTrackPageButton={this.props.handleTrackPageButton}
                            shouldShowAnimation={this.props.featureFlags && this.props.featureFlags.launchBrowseEventsAnimation}
                        />

                        <BrowseContainer />

                    </Layout>
                </ConditionalComponent>
            </ConnectedBasePage>
        );
    }
}
